import React from "react";

const CustomerDataContext = React.createContext({
    customer : null,
    loadingCustomer: false,
    setCustomer: () => {},
    setLoading : () => {}
});

export default CustomerDataContext;
